import { Component, OnInit } from '@angular/core';
import { ShellUpdateService, ShellUpdateMessage, ShellActionMessage } from '../../services/shell-update-service/shell-update.service';
import { AppConfigService } from '../../services/app-config-service/app-config.service';
import { Router, Route } from '@angular/router';
import { PatientDataService } from '../../services/patient-data/patient-data.service';
import { MatIconRegistry, MatSnackBar } from '@angular/material';
import { LoggingService } from '../../services/logging-service/logging.service';
import { UserSessionService } from '../../services/user-session-service/user-session.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthHttpClient } from '../../services/auth-http-service/auth-http.service';
import { Http, Headers, Response } from '@angular/http';
import { PDFProgressData } from 'ng2-pdf-viewer';
import { routerNgProbeToken } from '@angular/router/src/router_module';
import { HomeCardModel } from '../../models/home-card-model';
import { HomeCardService } from '../../services/home-card-service/home-card.service';

@Component({
    selector: 'app-portal-activity-view',
    templateUrl: './portal-activity-view.component.html',
    styleUrls: ['./portal-activity-view.component.css']
})
export class PortalActivityViewComponent implements OnInit {
    loaded: boolean;
    error: boolean;

    private patient: any;
    private reports: Report[];
    private largeView: any;

    myNotesCard: HomeCardModel

    constructor(private shellUpdateService: ShellUpdateService,
        private appConfigService: AppConfigService, private router: Router, private patientData: PatientDataService,
        iconRegistry: MatIconRegistry, private snackBar: MatSnackBar, private loggingService: LoggingService,
        private userSession: UserSessionService, private authHttpClient: AuthHttpClient,
        private homeCardService: HomeCardService) { }

    ngOnInit() {
        // Make sure the route being accessed is desirable (not user from admin, or admin from user. Redirect if required)
        this.userSession.checkRoute(this.router.url);

        this.myNotesCard = this.userSession.homeCards.find(x => x.CardName === 'MyNotes');

        this.shellUpdateService.sendShellUpdateMessage(new ShellUpdateMessage(
            this.appConfigService.ApplicationName, this.myNotesCard.Title, null, null));

        this.shellUpdateService.sendShellUpdateActionMessage(new ShellActionMessage(false, false, true, true, true));
        let reportId = null;
        this.router.routerState.root.queryParams.subscribe((params) => {
            reportId = params['reportId'];

        });
        this.getReportData(reportId);
    }

    private getReportData(reportId: number) {

        this.loggingService.log('Executing GetPatientData', this.appConfigService.LogToConsole);
        if (this.appConfigService.PatientId == null) {
            this.loggingService.log('No patient id', this.appConfigService.LogToConsole);
            this.loaded = true;
            return;
        }

        this.loggingService.log('Getting patient', this.appConfigService.LogToConsole);

        this.patientData.getPatient(this.appConfigService.PatientId).subscribe((response => {
            this.patient = response.json();

            if (this.patient.CurrentPregnancy == null) {
                this.loggingService.log('No current pregnancy', this.appConfigService.LogToConsole);
                this.loaded = true;
                return;
            }

            this.loggingService.log('Getting available reports', this.appConfigService.LogToConsole);
            this.patientData.getReports(this.patient.CurrentPregnancy.PregnancyId).map(response => response.json()).subscribe(response => {
                this.reports = response;

                // If we have a specified report id, use that and load the report full screen as it would have come from another url.
                if (reportId != null) {
                    this.fullScreen(reportId, null, this.reports.find(x => x.Id === reportId));
                }
                this.loaded = true;
            });

        }), (error: HttpErrorResponse) => {
            this.handleError(error);
        });
    }

    completed(progressData: PDFProgressData) {
        this.largeView.loaded = true;
        this.loggingService.log('PDF Loaded', this.appConfigService.LogToConsole);
    }

    handlePdfLoadError(error: any) {
        this.handleError(error);
    }

    exitFullScreen(event: Event) {
        this.loggingService.log('Quitting full screen', this.appConfigService.LogToConsole);

        // Prevents the click of the url from firing
        event.preventDefault();
        this.largeView = null;
    }

    fullScreen(id: number, event: Event, report: Report) {
        // Prevents the click of the url from firing
        if (event) {
            event.preventDefault();
        }

        this.loggingService.log('Loading full screen', this.appConfigService.LogToConsole);

        // Get the headers and append them to the sytem using an options object.
        var headers = this.authHttpClient.getHeaders();

        // Set the PDF source and then update the documents.
        this.largeView = {
            viewReport: report,
            loaded: false,
            pdfData: {
                url: this.appConfigService.ReportGet.replace('{reportId}', id.toString()).replace('{patientId}', this.appConfigService.PatientId.toString()),
                withCredentials: true,
                httpHeaders: headers
            }
        }
    }

    handleError(error: HttpErrorResponse) {
        switch (error.status) {
            case 0:
                this.error = true;
                this.snackBar.open('Sorry, we can\'t do that. You appear to be offline.', '', { duration: 5000 });
                this.loggingService.log('Error - offline', this.appConfigService.LogToConsole);
                break;
            case 401:
                this.error = true;
                this.snackBar.open('Sorry, we can\'t do that. Your login has expired.', '', { duration: 5000 });
                this.loggingService.log('Error - login expired', this.appConfigService.LogToConsole);
                this.userSession.logout();
                break;
            case 500:
                this.error = true;
                this.snackBar.open('Sorry, we can\'t do that. Server error.', '', { duration: 5000 });
                this.loggingService.log('Error - Server error', this.appConfigService.LogToConsole);
            default:
                break;
        }
    }



}

class Report {
    Name: string;
    DateCreated: string;
    PdfSrc: any = new Object;
    Id: number;
}


// WEBPACK FOOTER //
// ./src/app/views/portal-activity-view/portal-activity-view.component.ts